/*
 * @Author: 熊燕萍
 * @Date: 2022-01-21 17:49:42
 * @LastEditors: 熊燕萍
 * @LastEditTime: 2022-01-22 16:55:48
 * @Description: 全局组件注册
 * @FilePath: \ys.nbczpt\src\utils\globalComponents.js
 */
import YsTableList from 'components/common/YsTableList.vue';
import YsDaterangePicker from 'components/common/YsDaterangePicker.vue';
import YsFileuploader from 'components/common/YsMaxFileUploader.vue';

function plugins(Vue){
    Vue.component("YsTableList", YsTableList);
    Vue.component("YsDaterangePicker", YsDaterangePicker);
    Vue.component("YsFileuploader", YsFileuploader);
}
export default plugins;